export default __webpack_public_path__ + "fce36e2190f6193af1c493aef7e5cdf4.svg";